import React, { useEffect, useState } from 'react'
import { faStar } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { reviewsservice } from '../../../services/reviews'

const temporaryReviews = [
   {
      id: 1,
      name: "Ali Tufan",
      pic: "/avatars/1.png",
      since: "3 Days ago",
      title: "The best LMS Design",
      content: "This course is a very applicable. Professor Ng explains precisely each algorithm and even tries to give an intuition for mathematical and statistic concepts behind each algorithm. Thank you very much.",
      rating: 5,
      user_id: 1,
      course_id: 1
   },
   {
      id: 2,
      name: "Marie Dubois",
      pic: "/avatars/1.png",
      since: "1 Week ago",
      title: "Excellent contenu",
      content: "Très bon cours, les explications sont claires et les exercices pertinents. Je recommande !",
      rating: 4,
      user_id: 2,
      course_id: 1
   }
]

function Reviews({ course }) {
   const [reviews, setReviews] = useState([])
   const [loading, setLoading] = useState(false)
   const [submitting, setSubmitting] = useState(false)
   const [error, setError] = useState('')
   const [newReview, setNewReview] = useState({
      rating: 0,
      title: '',
      content: ''
   })
   const [hoverRating, setHoverRating] = useState(0)

   // Charger les reviews depuis l'API
   useEffect(() => {
      const loadReviews = async () => {
         if (!course?.id) return

         try {
            setLoading(true)
            // Appel réel à l'API
            // const response = await reviewsservice.getReviewsByCourseId(course.id)
            const response = await reviewsservice.getAllReviews();
            const list = Array.isArray(response) ? response : (response?.data ?? null);
            console.log('Fetched reviews from API:', list)

            if (list && list.length > 0) {
               setReviews(list)
            } else {
               console.log('Aucune review trouvée, utilisation des données temporaires')
               setReviews(temporaryReviews)
            }
         } catch (err) {
            console.error('Error loading reviews:', err)
            setError('Erreur lors du chargement des avis')
            // En cas d'erreur, utiliser les données temporaires
            setReviews(temporaryReviews)
         } finally {
            setLoading(false)
         }
      }

      loadReviews()
   }, [course?.id])

   // Gérer le changement des étoiles
   const handleStarClick = (rating) => {
      setNewReview(prev => ({ ...prev, rating }))
   }

   // Gérer le survol des étoiles
   const handleStarHover = (rating) => {
      setHoverRating(rating)
   }

   // Gérer la soumission du formulaire
   const handleSubmit = async (e) => {
      e.preventDefault()

      if (!newReview.rating) {
         setError('Veuillez donner une note')
         return
      }

      if (!newReview.title.trim()) {
         setError('Veuillez ajouter un titre')
         return
      }

      if (!newReview.content.trim()) {
         setError('Veuillez ajouter un contenu')
         return
      }

      try {
         setSubmitting(true)
         setError('')

         const reviewData = {
            course_id: course.id,
            user_id: 1, // À remplacer par l'ID de l'utilisateur connecté
            rating: newReview.rating,
            title: newReview.title,
            content: newReview.content,
            is_verified_purchase: true
         }

         // APPEL RÉEL À L'API POUR CRÉER LA REVIEW
         const response = await reviewsservice.createReviews(reviewData)

         if (response) {
            // Ajouter la nouvelle review à la liste
            const createdReview = {
               id: response?.id || Date.now(),
               name: "Vous", // Ou le nom de l'utilisateur connecté
               pic: "/avatars/1.png",
               since: "À l'instant",
               title: newReview.title,
               content: newReview.content,
               rating: newReview.rating,
               user_id: 1,
               course_id: course.id
            }

            setReviews(prev => [createdReview, ...prev])

            // Réinitialiser le formulaire
            setNewReview({
               rating: 0,
               title: '',
               content: ''
            })
            setHoverRating(0)

            setError('') // Clear any previous errors
         } else {
            setError(response.message || 'Erreur lors de la création de l\'avis')
         }

      } catch (err) {
         console.error('Error submitting review:', err)
         setError('Erreur lors de la soumission de l\'avis: ' + (err.response?.data?.message || err.message))
      } finally {
         setSubmitting(false)
      }
   }

   // Gérer les changements des champs
   const handleInputChange = (e) => {
      const { name, value } = e.target
      setNewReview(prev => ({ ...prev, [name]: value }))
      // Clear error when user starts typing
      if (error) setError('')
   }

   // Gérer les votes "utile"
   const handleHelpfulVote = async (reviewId, isHelpful) => {
      try {
         // Implémenter la logique de vote ici si besoin
         console.log(`Review ${reviewId} marked as ${isHelpful ? 'helpful' : 'not helpful'}`)
         // await reviewsService.voteHelpful(reviewId, isHelpful)
      } catch (err) {
         console.error('Error voting:', err)
      }
   }

   if (loading && reviews.length === 0) {
      return (
         <div className="flex justify-center items-center py-8">
            <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-purple-1"></div>
         </div>
      )
   }

   return (
      <div>
         <div className='mt-14'>
            <h4 className='text-dark-2 dark:text-white font-medium text-xl'>Avis ({reviews.length})</h4>

            {error && (
               <div className="mt-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
                  {error}
               </div>
            )}

            <div className="space-y-4 py-[30px]">
               {reviews.length === 0 ? (
                  <p className="text-gray-500 dark:text-gray-300 text-center py-8">
                     Aucun avis pour le moment. Soyez le premier à donner votre avis !
                  </p>
               ) : (
                  reviews.map((review, index) => (
                     <div key={review.id} className={`flex items-start ${index < reviews.length - 1 ? 'border-b mb-[30px] pb-[60px]' : 'border-none mb-[30px]'}`}>
                        <img src={review.pic} alt={review.name} className="rounded-full w-12 h-12" />
                        <div className="ml-7 flex-1">
                           <div className="flex items-center justify-between">
                              <p className="font-medium text-dark-1 dark:text-white">
                                 {review.name}
                                 <span className='text-xs ml-2 text-gray-500 dark:text-gray-300'>{review.since}</span>
                              </p>
                              <div className="flex text-yellow-600 gap-x-1">
                                 {[...Array(5)].map((_, i) => (
                                    <FontAwesomeIcon
                                       key={i}
                                       icon={faStar}
                                       className={`w-4 h-4 ${i < review.rating ? 'text-yellow-500' : 'text-gray-300'}`}
                                    />
                                 ))}
                              </div>
                           </div>
                           <p className="text-dark-1 text-sm mt-2 font-medium dark:text-white">
                              {review.title}
                           </p>
                           <p className="mt-3 text-gray-500 text-[15px] font-sans dark:text-gray-300">
                              {review.content}
                           </p>
                           <div className='flex items-center mt-5'>
                              <span className='text-purple-1 text-sm'>Cet avis vous a-t-il été utile ?</span>
                              <button
                                 onClick={() => handleHelpfulVote(review.id, true)}
                                 className="text-white bg-purple-1 w-[50px] items-center flex ml-3 h-[30px] px-3 py-2 rounded-lg border border-purple-1 hover:text-purple-1 hover:bg-white text-sm"
                              >
                                 Oui
                              </button>
                              <button
                                 onClick={() => handleHelpfulVote(review.id, false)}
                                 className="text-purple-1 bg-light-3 w-[50px] items-center flex ml-3 h-[30px] px-3 py-2 rounded-lg border border-light-3 hover:text-white hover:border-purple-1 hover:bg-purple-1 text-sm"
                              >
                                 Non
                              </button>
                           </div>
                        </div>
                     </div>
                  ))
               )}
            </div>
         </div>

         {/* Formulaire d'ajout d'avis */}
         <div className='mt-2'>
            <form onSubmit={handleSubmit}>
               <div className="mt-8">
                  <h4 className='text-dark-2 font-medium text-base dark:text-white mb-3'>
                     Donner une note
                  </h4>
                  <div className="flex text-yellow-600 gap-x-2 mr-2 p-3 -my-1">
                     {[...Array(5)].map((_, i) => {
                        const starValue = i + 1
                        return (
                           <FontAwesomeIcon
                              key={i}
                              icon={faStar}
                              className={`w-6 h-6 cursor-pointer transition-colors ${starValue <= (hoverRating || newReview.rating)
                                    ? 'text-yellow-500'
                                    : 'text-gray-300'
                                 }`}
                              onClick={() => handleStarClick(starValue)}
                              onMouseEnter={() => handleStarHover(starValue)}
                              onMouseLeave={() => setHoverRating(0)}
                           />
                        )
                     })}
                  </div>
               </div>

               <div className="mt-8">
                  <h4 className='text-dark-2 font-medium text-base dark:text-white mb-3'>
                     Titre de l'avis
                  </h4>
                  <input
                     type="text"
                     name="title"
                     placeholder="Great Courses"
                     value={newReview.title}
                     onChange={handleInputChange}
                     className='w-full bg-white dark:bg-dark-5 dark:text-white flex rounded-lg items-center py-4 px-5 border text-black outline-none'
                  />
               </div>

               <div className="mt-8">
                  <h4 className='text-dark-2 font-medium text-base dark:text-white mb-3'>
                     Contenu de l'avis
                  </h4>
                  <textarea
                     name="content"
                     placeholder="Message"
                     rows="8"
                     value={newReview.content}
                     onChange={handleInputChange}
                     className='w-full bg-white flex rounded-lg items-center py-4 px-5 border text-black outline-none dark:bg-dark-5 dark:text-white'
                  />
               </div>

               <div className="mt-8 w-full p-3 font-sans">
                  <button
                     type='submit'
                     disabled={submitting}
                     className='text-[16px] h-[60px] px-14 py-3 bg-purple-1 border border-purple-1 text-white hover:bg-white hover:text-purple-1 rounded-lg dark:hover:bg-dark-5 disabled:opacity-50 disabled:cursor-not-allowed'
                  >
                     {submitting ? 'Envoi en cours...' : 'Soumettre'}
                  </button>
               </div>
            </form>
         </div>
      </div>
   )
}

export default Reviews